import * as React from "react";

export const IconArrowShapeUp = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 10.5V7.5H1.5L6 2L10.5 7.5H8V10.5H4Z" fill="currentColor" />
  </svg>
);
